import { resolveSurveyCampaignUrl, resolveMessagesBroadcasts } from './redirects'

export function resolveRedirectUrl(redirectUrl: string | undefined, newProjectId: string): boolean {
  const pathname = window.location.pathname

  if (/\/survey_campaign(\/|\?|$)/.test(pathname)) {
    const url = resolveSurveyCampaignUrl(redirectUrl || window.location.href, newProjectId)
    loadMainBody(url)
    return true
  }

  if (/\/charities\/\d+\/messages/.test(pathname)) {
    return resolveMessagesBroadcasts(newProjectId)
  }

  return false
}
